import {store} from '../store';
import {DISPLAY_DATE_FORMAT,DB_DATE_FORMAT} from '../constants';
import moment from 'moment';
//const dispatch = useDispatch();
export const createCookie=(name, value, days)=> {
    let expires;
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(name + "=");
        if (c_start !== -1) {
            deleteCookie(name);
        }
    }
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    else {
        expires = "";
    } 
        document.cookie = name + "=" +value+ expires + ";path=/";
}

export const getCookie=(c_name)=> {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start !== -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end === -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}

export const deleteCookie=(c_name)=>{
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start !== -1) {
            let dt=new Date();
            dt.setFullYear(1970);
            document.cookie = c_name + "=;expires="+dt.toGMTString()+";path=/";
        }
    }
}
export const getAccessToken=()=> { 
    return getCookie('access_token');
}
  export const getRefreshToken=()=> {
    // grab current state
   // const _state = store.getState();
    //const refreshToken = _state.users.authInfo.refresh_token;
   // return refreshToken
   return getCookie('refresh_token');
   
  }
  export const saveNewAccessToken=(respObj)=>{
    const _state = store.getState();
    let authInfo=_state.users.authInfo;
    authInfo.access_token=respObj.access_token;
    createCookie('access_token', respObj.access_token ,respObj.expires);
  }

  export const convertToDateString=(date,format=undefined)=>{
      try{
          if(format){
            return moment(date,format).format(DISPLAY_DATE_FORMAT)
          }else{
            return moment(date).format(DISPLAY_DATE_FORMAT)
          }
      }catch(e){
          return '';
      }
  }

  export const convertFloat=(value)=>{
      try{
          return parseFloat((value||'').toString());
      }
      catch(e){
          return 0.00;
      }
  }
  export const convertToFloat=(value,decimalLength=2)=>{
    return parseFloat((isNaN(parseFloat(value))?0.00:parseFloat(value)).toFixed(decimalLength));
    
  }
  export const download_csv=(data,fileName) =>{
    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(data);
    hiddenElement.target = '_blank';
    hiddenElement.download = fileName;
    hiddenElement.click();
}
export const groupBy=(list, props)=> {
    return list.reduce((a, b) => {
       (a[b[props]] = a[b[props]] || []).push(b);
       return a;
    }, {});
  }